<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item prop="postId">
                <span slot="label"><a-tooltip>{{ $t('帖子ID') }}<template slot="title"><!--提示内容--> </template></a-tooltip></span>
                <a-input v-model="queryParam.postId" :maxLength="32" :placeholder="$t('请输入')+'帖子ID'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="auditType">
                <span slot="label"><a-tooltip>{{ $t('审核类型') }}<template slot="title"><!--提示内容--> </template></a-tooltip></span>
                <a-select v-model="queryParam.auditType" :placeholder="$t('请选择')+'审核类型'" allow-clear style="width: 100%">
                  <a-select-option :value="1">{{ $t('文本') }}</a-select-option>
                  <a-select-option :value="2">{{ $t('图片') }}</a-select-option>
                  <a-select-option :value="3">{{ $t('视频') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="taskStatus">
                <span slot="label"><a-tooltip>{{ $t('任务状态') }}<template slot="title"><!--提示内容--> </template></a-tooltip></span>
                <a-select v-model="queryParam.taskStatus" :placeholder="$t('请选择')+'任务状态'" allow-clear style="width: 100%">
                  <a-select-option :value="0">{{ $t('待审核') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('审核完成') }}</a-select-option>
                  <a-select-option :value="2">{{ $t('审核异常') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="suggestion">
                <span slot="label"><a-tooltip>{{ $t('审核结果') }}<template slot="title"><!--提示内容--> </template></a-tooltip></span>
                <a-select v-model="queryParam.suggestion" :placeholder="$t('请选择')+'审核结果'" allow-clear style="width: 100%">
                  <a-select-option value="pass">{{ $t('通过') }}</a-select-option>
                  <a-select-option value="review">{{ $t('需复审') }}</a-select-option>
                  <a-select-option value="fail">{{ $t('违规') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker
                    style="width: 100%"
                    v-model="queryParam.createBeginTime"
                    :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker
                    style="width: 100%"
                    v-model="queryParam.createEndTime"
                    :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['community:communitypostaudit:delete']">
          <a-icon type="delete" />{{ $t('删除违规帖子') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 2000 }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="finishTime" slot-scope="text, record">
          {{ record.finishTime ? parseTime(record.finishTime) : '-' }}
        </span>
        <span slot="auditType" slot-scope="text, record">
          {{ record.auditType === 1 ? $t('文本') : record.auditType === 2 ? $t('图片') : record.auditType === 3 ? $t('视频') : '-' }}
        </span>
        <span slot="taskStatus" slot-scope="text, record">
          <a-tag :color="record.taskStatus === 0 ? 'orange' : record.taskStatus === 1 ? 'green' : 'red'">
            {{ record.taskStatus === 0 ? $t('待审核') : record.taskStatus === 1 ? $t('审核完成') : record.taskStatus === 2 ? $t('审核异常') : '-' }}
          </a-tag>
        </span>
        <span slot="suggestion" slot-scope="text, record">
          <a-tag :color="record.suggestion === 'pass' ? 'green' : record.suggestion === 'review' ? 'orange' : record.suggestion === 'fail' ? 'red' : 'default'">
            {{ record.suggestion === 'pass' ? $t('通过') : record.suggestion === 'review' ? $t('需复审') : record.suggestion === 'fail' ? $t('违规') : record.suggestion || '-' }}
          </a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDelete(record)" v-hasPermi="['community:communitypostaudit:delete']">
            <a-icon type="delete" />{{ $t('删除帖子') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCommunityPostAudit, deleteViolationCommunityPost } from '@/api/community/communityGroup/communityPostAudit'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CommunityPostAudit',
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        postId: undefined,
        auditType: undefined,
        taskStatus: undefined,
        suggestion: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('编号'),
          dataIndex: 'id',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('帖子ID'),
          dataIndex: 'postId',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('审核类型'),
          dataIndex: 'auditType',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'auditType' }
        },
        {
          title: this.$t('审核内容'),
          dataIndex: 'content',
          width: 300,
          align: 'center',
          ellipsis: true
        },
        {
          title: this.$t('任务状态'),
          dataIndex: 'taskStatus',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'taskStatus' }
        },
        {
          title: this.$t('审核结果'),
          dataIndex: 'suggestion',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'suggestion' }
        },
        {
          title: this.$t('违规标签'),
          dataIndex: 'labels',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: this.$t('异常原因'),
          dataIndex: 'failReason',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: this.$t('重试次数'),
          dataIndex: 'retryCount',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: this.$t('完成时间'),
          dataIndex: 'finishTime',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'finishTime' }
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: 120,
          scopedSlots: { customRender: 'operation' },
          fixed: 'right',
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  methods: {
    moment,
    getTotal (total) {
      return this.$t('共') + total + this.$t('条')
    },
    /** 查询审核任务列表 */
    getList () {
      this.loading = true
      pageCommunityPostAudit(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        postId: undefined,
        auditType: undefined,
        taskStatus: undefined,
        suggestion: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange (pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.postId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 - 删除违规帖子 */
    handleDelete (row) {
      var that = this
      const ids = row.postId || this.ids
      if (row.postId) {
        this.ids = []
        this.ids.push(row.postId)
      }
      const reqData = { 'idList': this.ids }
      this.$confirm({
        title: this.$t('确认删除所选中帖子'),
        content: this.$t('删除后将不可恢复'),
        onOk () {
          return deleteViolationCommunityPost(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message, 3)
            })
        },
        onCancel () {
          that.ids = []
        }
      })
    }
  }
}
</script>
